document.addEventListener('DOMContentLoaded', function () {
  console.log('Produktarchiv-Skript geladen.');

  // Variable, um den zuletzt geklickten Warenkorb-Button zu speichern
  let lastClickedButton = null;

  const modal = document.getElementById('variant-modal');
  const modalContent = modal.querySelector('.custom-modal-content');
  const modalCloseButton = document.querySelector('.custom-close-button');
  const variantSelectModal = document.getElementById('variant-select-modal');
  const addToCartModalButton = document.querySelector('.modal-add-to-cart-button');

  // Funktion, die den Button nach erfolgreichem Hinzufügen aktualisiert und nach 2 Sekunden wieder zurücksetzt
  function showCheckmark(button) {
    if (button) {
      // Zeige Checkmark SVG
      button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1F6E2C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
      button.classList.add('added');
      // Nach 2 Sekunden wieder zurücksetzen
      setTimeout(function() {
        // Hier wird das neue Warenkorb-SVG eingesetzt:
        button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30" fill="currentColor"><rect x="7" y="8" width="10" height="12" rx="2" /><path d="M9 8a3 3 0 0 1 6 0v1" stroke="currentColor" stroke-width="0.9" fill="none" /></svg>';
        button.classList.remove('added');
      }, 2000);
    }
  }

  // Öffnen des Modals oder direktes Hinzufügen zum Warenkorb
  document.querySelectorAll('.product-grid-add-to-cart-button').forEach(button => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      // Speichere den Button, der das Add-to-Cart ausgelöst hat
      lastClickedButton = this;

      console.log('Add-to-Cart-Button geklickt.');

      const productHandle = this.getAttribute('data-product-handle');
      console.log('Produkt-Handle:', productHandle);

      // Produktdaten laden
      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          console.log('Produktdaten geladen:', product);

          if (product.variants.length > 1) {
            // Modal öffnen, wenn es mehrere Varianten gibt
            modal.style.display = 'flex';
            modalContent.style.display = 'block';

            // Varianten-Dropdown befüllen
            variantSelectModal.innerHTML = '';
            product.variants.forEach(variant => {
              const option = document.createElement('option');
              option.value = variant.id;
              option.textContent = `${variant.title} - ${(variant.price / 100).toFixed(2)} €`;
              variantSelectModal.appendChild(option);
            });
          } else {
            // Direktes Hinzufügen zum Warenkorb, wenn es nur eine Variante gibt
            const variantId = product.variants[0].id;

            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ id: variantId, quantity: 1 }),
            })
              .then(response => response.json())
              .then(data => {
                console.log('Produkt erfolgreich hinzugefügt:', data);
                showCheckmark(lastClickedButton);
                updateCartDisplay();
              })
              .catch(error => {
                console.error('Fehler beim Hinzufügen zum Warenkorb:', error);
              });
          }
        })
        .catch(error => {
          console.error('Fehler beim Laden des Produkts:', error);
        });
    });
  });

  // Schließen des Modals
  modalCloseButton.addEventListener('click', () => {
    modal.style.display = 'none';
    modalContent.style.display = 'none';
    console.log('Modal geschlossen.');
  });

  // Hinzufügen zum Warenkorb aus dem Modal
  addToCartModalButton.addEventListener('click', () => {
    const variantId = variantSelectModal.value;

    if (!variantId) {
      alert('Bitte eine Variante auswählen.');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Produkt erfolgreich hinzugefügt:', data);

        // Modal schließen
        modal.style.display = 'none';
        modalContent.style.display = 'none';
        showCheckmark(lastClickedButton);
        updateCartDisplay();
      })
      .catch(error => {
        console.error('Fehler beim Hinzufügen zum Warenkorb:', error);
      });
  });

  // Warenkorbanzeige aktualisieren
  function updateCartDisplay() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count > 0 ? cart.item_count : '0';
        });
      })
      .catch(error => {
        console.error('Fehler beim Aktualisieren des Warenkorbs:', error);
      });
  }
});

// lange Produktbeschreibung Toggle
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.description-toggle');
  const content = document.querySelector('.description-content');
  const icon = toggle.querySelector('.toggle-icon');

  toggle.addEventListener('click', () => {
    content.classList.toggle('visible');
    if (content.classList.contains('visible')) {
      icon.textContent = '−'; // Ändert das "+" zu "−"
    } else {
      icon.textContent = '+'; // Setzt das "+" zurück
    }
  });
});
